<div class="page-loader-wrapper" *ngIf="showLoading">
    <div class="loader">
      <div class="m-t-30"><img class="zmdi-hc-spin" src="//nsiainsurance.com/assets/img/fav.png" width="120" height="120"
          alt="Compass"></div>
      <p>Please wait...</p>
    </div>
  </div>